import React, { useState, Component, Fragment } from "react";
import Switch from "@material-ui/core/Switch";
import { Navigationmenu } from "../components";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactSession from "../reactclient.js";
import { withRouter } from "react-router-dom";
import circulargridimage from "../gallery/gridloader.gif";

import DatePicker from "react-datepicker";
import moment, { max } from "moment";
// import 'react-datepicker/dist/react-datepicker.css';
import Footer from "../components/Footer";
import {
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  MuiEditableLabel,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Popover,
  Dialog,
  Tabs,
  Tab,
  DialogActions,
  withStyles,
  TableFooter,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  SearchOutlined,
  ArrowDropDown,
  Publish,
  NoteAdd,
  ArrowDropUp,
  InsertDriveFileOutlined,
  AlternateEmail,
  AlternateEmailTwoTone,
} from "@material-ui/icons";
import {
  ALTERNATEROW_BACKGROUND_COLOR,
  BLUE_COLOR,
  LIGHTGRAY_COLOR,
  MODIFIEDBLACK,
  PINK_COLOR,
  PROTECT_GREEN,
  RED_COLOR,
  VIBRANT_GREEN,
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from "render-if";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { findAllByPlaceholderText } from "@testing-library/react";
import { fnPostapiResponse, fnGETapiResponse, Fnencryption } from "../APICall";

const StyledTabs = withStyles(
  {
    indicator: {
      display: "flex",
      backgroundColor: "white",
      height: 3,
    },
  },
  { index: 1 }
)((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles(
  (theme) => (
    {
      root: {
        textTransform: "none",
        color: "white",
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        "&:focus": {
          opacity: 1,
        },
      },
    },
    { index: 1 }
  )
)((props) => <Tab disableRipple {...props} />);

export default class ABDPage extends Component {
  state = {
    tablebuffer: [],
    pageSize: 10,
    showPager: false,
    SOURCE: "",
    IsWindowsAuth: "",
    SNAME: "",
    SNAMElabel: "",
    DOB: "",
    DBUserName: "",
    DBPassword: "",
    DBSource: "",
    DBProvider: "",
    test: false,
    isloading: false,
    pagesObj: [],
    selectedUser: "",
    newOBJ: [],
    selectedPass: "",
    ismandatory: false,
    pageloadingdata: 0,
    redirect: false,
    direction: "SearchPage",
    showModal: false,
    tablebuffer: [],
    pages: 0,
    current: 1,
    records: 0,
    pageSize: 10,
    showPager: false,
    SearchButtonDisable: false,
    RefreshButtonDisable: false,
    SOURCE: "",
    FNAME: "",
    SNAME: "",
    ACCOUNTDETAILNO: "",
    pagesObj: [],
    SavebuttonDisable: false,
    searchbuttonbackcolor: BLUE_COLOR,
    clearbuttonbackcolor: BLUE_COLOR,
    isloading: false,
    isadmin: false,
    isadminSwitch: false,
    ShowOccupation: true,
    diableRadio: true,
    BeneFitPayble: false,
    ChckOnboarding: true,
    disableSelectedINTROType: false,
    disableSelectedpaymentType: false,
    disableBenef: false,
    Nainpayment: true,
    NANSourceOfFund: true,
    NANSourceOfIntroduction: true,
    NANBenef: true,
    clearresult: true,
  };

  componentDidMount() {

    this.setState({
      SearchButtonDisable: false,
      searchbuttonbackcolor: BLUE_COLOR,
      RefreshButtonDisable: false,
      clearbuttonbackcolor: BLUE_COLOR,
    });
 
    // var loggedinuser = sessionStorage.getItem("username");

    // if (
    //   loggedinuser == "TRTIROUVEN" ||
    //   loggedinuser == "PGPRISCILL" ||
    //   loggedinuser == "NCNEELESH" ||
    //   loggedinuser == "SBSURYAVAN" ||
    //   loggedinuser == "LEONG" ||
    //   loggedinuser == "ASEETOHUL"
    // ) {
    //   this.setState({
    //     SearchButtonDisable: false,
    //     searchbuttonbackcolor: BLUE_COLOR,
    //     RefreshButtonDisable: false,
    //     clearbuttonbackcolor: BLUE_COLOR,
    //   });
    // } else {
    //   this.setState({
    //     SearchButtonDisable: true,
    //     searchbuttonbackcolor: LIGHTGRAY_COLOR,
    //     RefreshButtonDisable: true,
    //     clearbuttonbackcolor: LIGHTGRAY_COLOR,
    //   });
    // }
  }

  handleChange = (event) => {
    this.setState({ isadmin: event.target.checked });
  };
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleLeavePage);
  }

  handleLeavePage(e) {
    const confirmationMessage = "My message";
    e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
    return confirmationMessage; // Gecko, WebKit, Chrome <34
  }

  pageChange(number) {
    this.state.current = number;
    var data = this.state.alldata.slice(
      this.state.current * this.state.pageSize,
      (this.state.current + 1) * this.state.pageSize
    );
    this.setState({ tablebuffer: data });

    this.state.pagesObj = [];
    if (this.state.pages < 10) {
      for (var i = 0; i < this.state.pages; i++) this.state.pagesObj.push(i);
    } else {
      var min = this.state.current - 5;
      var max = this.state.current + 5;
      if (min < 0) min = 0;
      if (max > this.state.pages) max = this.state.pages;
      if (max - min > 10) {
        min = this.state.current - 5;
        max = this.state.current + 5;
      }
      if (min > 0) this.state.pagesObj.push(0);
      for (var i = min; i < max; i++) this.state.pagesObj.push(i);
      if (max < this.state.pages - 1)
        this.state.pagesObj.push(this.state.pages - 1);
    }
  }
  renderpages() {
    this.state.records = this.state.alldata.length;
    this.state.pages = parseInt(this.state.records / this.state.pageSize);
    if (this.state.records % this.state.pageSize > 0) this.state.pages++;
    this.state.showPager = this.state.pages > 1;
    this.pageChange(0);
  }

  clearScreen() {
    var r = window.confirm("Do you want to Clear ?");
    if (r == true) {
      this.setState({
        SNAME: "",
        FNAME: "",
        isloading: false,
        SearchButtonDisable: false,
        searchbuttonbackcolor: BLUE_COLOR,
        tablebuffer: [],
        pagesObj: [],
      });
    }
  }

  handletextChange(e, key) {
    this.setState({ key: e.target.value });
    this.state[key] = e.target.value;
  }

  fntocheckMandatory(e) {
    if (e == "SEARCHABD") {
      if (
        this.state.SNAME == null ||
        this.state.SNAME == "" ||
        this.state.FNAME == null ||
        this.state.FNAME == ""
      ) {
        alert("Please enter the compulsory details (Surname and First Name)");
        this.state.ismandatory = false;
      } else {
        this.state.ismandatory = true;
      }
    }
  }

  RefinitiveresponseABD(e) {
    this.fntocheckMandatory(e);

    if (this.state.ismandatory) {
      if (e == "SEARCHABD") {
        this.refinitsearchfun(e);
        this.setState({
          SearchButtonDisable: true,
          searchbuttonbackcolor: LIGHTGRAY_COLOR,
        });
      }
    }
  }

  // searchandsave(data, count, refinitivCount) {
  //   var searchdate = "";
  //   if (this.state.selectedOption) {
  //     var date = new Date();
  //     var month =
  //       date.getMonth() + 1 < 10
  //         ? "0" + (date.getMonth() + 1)
  //         : date.getMonth() + 1;
  //     var date1 = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  //     var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1;
  //     if (this.state.DOB == CMLSELECTEDATE) searchdate = "";
  //     else searchdate = this.state.DOB;
  //   } else {
  //     searchdate = this.state.DOB;
  //   }
  //   if (this.state.SelectedClientType == "CORPORATE") {
  //     searchdate = "";
  //   }
  //   var data1 = {
  //     MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
  //     MAPINAME:
  //       "SaveAMLSourceApi?AMLSearchCount=" +
  //       count +
  //       "&RefinitivSearchCount=" +
  //       refinitivCount,
  //     MAPIPORT: "" + process.env.REACT_APP_MPORT1 + "",
  //     body: {
  //       NIC: this.state.NIC || "",
  //       FNAME: this.state.FNAME || "",
  //       SNAME: this.state.SNAME || "",
  //       CASELOG_LINKID: "",
  //       AMLSource: this.state.SOURCE || "",
  //       Company: this.state.SelectedCompany || "",
  //       ClientNo: this.state.SelectedClientName || "",
  //       ClientType: this.state.SelectedClientType || "",
  //       Dob: searchdate || "",
  //       Gender: this.state.amlgender || "",
  //       Nationality: this.state.selectedCountry || "",
  //       CaseId: this.state.caseid || "",
  //       DBUserName: this.state.selectedUser || "",
  //       DBPassword: Fnencryption(this.state.selectedPass) || "",
  //       DBSource: this.state.DBSource || "",
  //       DBProvider: this.state.DBProvider || "",
  //       QuickFullSearch: this.state.selectedOption || "",
  //       Test: this.state.test,
  //       IsWindowsAuth:
  //         this.state.IsWindowsAuth == null ? "False" : this.state.IsWindowsAuth,
  //     },
  //   };
  //   //  console.log("da",data1)
  //   fnPostapiResponse(
  //     process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
  //     "PostApiMiddleWare",
  //     data1,
  //     process.env.REACT_APP_PORT_MIDDLEWARE
  //   )
  //     .then((response) => {
  //       // console.log("Data",response.data)
  //     })
  //     .catch(
  //       (e) => console.log(e)
  //       // this.setState({ alldata: [], isloading: false }),
  //       // this.renderpages()
  //     );
  // }

  isEven(n) {
    return n % 2 == 0;
  }

  refinitsearchfun(e) {
    this.setState({ alldata: [] });
    this.state.pagesObj = [];
    this.state.newOBJ = [];

    var data = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETACTISUREBANKDETAILS",
      MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
      body: {
        strSurname: this.state.SNAME || "",
        strFirstName: this.state.FNAME || "",
      },
    };
    this.state.isloading = true;
    fnPostapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "PostApiMiddleWare",
      data,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        //console.log("NEWOBJ", response1.data.SearchResultMSG)
        this.setState({ newOBJ: response.data.recordset });
        // this.setState({ newOBJ: response1.data.Message })
        // console.log("New OBJ => ", response.data.recordset);
        // console.log("New OBJi => ", this.state.newOBJ);
        // console.log("After Merge Obj => ", this.state.newOBJ.concat(response.data.SearchResultMSG))
        if (
          this.state.newOBJ == null ||
          this.state.newOBJ == "null" ||
          this.state.newOBJ == "" ||
          this.state.newOBJ == undefined
        ) {
          alert("No Data Found");
          this.setState({
            alldata: response.data.recordset,
            isloading: false,
            SearchButtonDisable: false,
            searchbuttonbackcolor: BLUE_COLOR,
          });
        }
        if (this.state.newOBJ.length > 100) {
          var r = window.confirm(
            "Many Records matched search Criteria. Ok to Proceed or Cancel to redefine Search Criteria"
          );
          if (r) {
            // this.searchandsave(
            //   data,
            //   response.data.recordset.length,
            // );
            this.setState({
              isloading: false,
              alldata: this.state.newOBJ,
            });
            this.renderpages();
          } else {
            this.setState({ alldata: [], isloading: false });
            this.renderpages();
          }
        } else {
          // this.searchandsave(
          //   data,
          //   response.data.recordset.length
          // );

          this.setState({
            alldata: this.state.newOBJ,
            isloading: false,
          });
        }
        this.renderpages();
        // if (
        //   this.state.newOBJ.length == 0
        // )
        //   alert("No data found!");
      })
      .catch((e) => console.log(e));
  }

  render() {
    return (
      <Fragment>
        <Navigationmenu selectedMenu={"ABDPage"} />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ marginTop: 35 }}
        >
          <Paper
            elevation={2}
            style={{ minHeight: 100, width: "90%", borderRadius: 6 }}
          >
            <form>
              <Box display="flex" alignItems="center" justifyContent="center">
                <div style={{ minHeight: 100, width: "98%", borderRadius: 6 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={11}>
                      <div
                        style={{
                          display: "flex",
                          marginBottom: 20,
                          marginTop: 60,
                        }}
                      >
                        <Typography
                          style={{
                            borderWidth: 0,
                            color: BLUE_COLOR,
                            textTransform: "uppercase",
                            fontFamily: "Globerbold",
                            fontSize: 30,
                            paddingLeft: 10,
                          }}
                        >
                          Actisure Bank Details
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    style={{ width: "calc(100% + 200px)" }}
                  >
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                      }}
                    >
                      SURNAME
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        fullWidth
                        label="Surname"
                        value={this.state.SNAME}
                        onChange={(e) => this.handletextChange(e, "SNAME")}
                        variant="outlined"
                      />
                    </Grid>
                    <label
                      style={{
                        display: this.state.isdisplayswitch,
                        color: RED_COLOR,
                        fontSize: 35,
                      }}
                    >
                      *
                    </label>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    style={{ width: "calc(100% + 200px)" }}
                  >
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                        width: "calc(100% + 200px)",
                      }}
                    >
                      FIRST NAME
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        fullWidth
                        label="First Name"
                        value={this.state.FNAME}
                        onChange={(e) => this.handletextChange(e, "FNAME")}
                        variant="outlined"
                      />
                    </Grid>
                    <label
                      style={{
                        display: this.state.isdisplayswitch,
                        color: RED_COLOR,
                        fontSize: 35,
                      }}
                    >
                      *
                    </label>
                    <Grid item xs={3} style={{ maxWidth: "22%" }}></Grid>
                    <Button
                      variant={"text"}
                      disabled={this.state.SearchButtonDisable}
                      onClick={(e) => this.RefinitiveresponseABD("SEARCHABD")}
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: this.state.searchbuttonbackcolor,
                        width: "7%",
                        fontSize: 18,
                        height: "53px",
                        marginTop: "9px",
                        marginRight: "15px",
                      }}
                    >
                      Search
                    </Button>
                    <Button
                      variant={"text"}
                      disabled={this.state.RefreshButtonDisable}
                      onClick={(e) => this.clearScreen()}
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: this.state.clearbuttonbackcolor,
                        width: "7%",
                        fontSize: 18,
                        height: "53px",
                        marginTop: "9px",
                        marginRight: "7px",
                      }}
                    >
                      Clear
                    </Button>
                  </Grid>
                  <br></br>
                  <br></br>
                  <br></br>
                  <Grid item xs>
                    <TableContainer>
                      <Table aria-label="table">
                        <TableHead
                          style={{ backgroundColor: "rgba(241,241,241,1.0)" }}
                        >
                          <TableRow>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Account Detail No
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Account Name
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Entity ID
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              First Name
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Surname
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Company Name
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Account Number
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Sort Code
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              IsDefault
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              IsActive
                            </TableCell>
                            <TableCell
                              style={{
                                borderWidth: 0,
                                width: "170px",
                                color: MODIFIEDBLACK,
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                              }}
                              align="left"
                            >
                              Changed Date
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {!this.state.isloading ? (
                            this.state.tablebuffer.map((obj, index) => {
                              var rowbackgroundColor = "white";
                              if (this.isEven(index)) {
                                rowbackgroundColor =
                                  ALTERNATEROW_BACKGROUND_COLOR;
                              }

                              if (
                                this.state.ishovered &&
                                this.state.hoverindex == index
                              ) {
                                rowbackgroundColor = LIGHTGRAY_COLOR;
                              }
                              if (obj != undefined) {
                                return (
                                  <TableRow
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      this.setState({ showDialog: true })
                                    }
                                    key={index}
                                    hover={true}
                                    onMouseOut={() =>
                                      this.setState({ ishovered: false })
                                    }
                                    onMouseEnter={() =>
                                      this.setState({
                                        hoverindex: index,
                                        ishovered: true,
                                      })
                                    }
                                  >
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.AccountDetailNo}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AccountName"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.EntityID}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["FirstName"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["Surname"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["CompanyName"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["AccountNumber"]}
                                    </TableCell>
                                    {/* <TableCell style={{ borderWidth: 0, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="left">{obj["SetNo"]}</TableCell> */}
                                    {/* <TableCell style={{width: 0,height: 0,borderRadius: '50%',backgroundColor: obj["ColorCoding"],padding:10}}></TableCell> */}
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["SortCode"]}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.IsDefault}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj.IsActive}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        borderWidth: 0,
                                        whiteSpace: "unset",
                                        color: BLUE_COLOR,
                                        textTransform: "uppercase",
                                        fontFamily: "Globerbold",
                                        backgroundColor: rowbackgroundColor,
                                      }}
                                      align="left"
                                    >
                                      {obj["changedate"]}
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            })
                          ) : (
                            <td
                              style={{ marginLeft: "500px", height: "100px" }}
                            >
                              {/* Loading.... <CircularProgress classes="CircularProgress" /> */}
                              <img
                                style={{ width: "100px" }}
                                src={circulargridimage}
                                alt="circulargridimage"
                              />
                              ;
                            </td>
                          )}
                        </TableBody>
                      </Table>
                      <div
                        style={
                          this.state.showPager
                            ? {
                                height: 60,
                                marginLeft: "500px",
                                color: MODIFIEDBLACK,
                                fontSize: "15px",
                                textTransform: "uppercase",
                                fontFamily: "Globerbold",
                                wordBreak: "break-word",
                              }
                            : { display: "none" }
                        }
                      >
                        {this.state.pagesObj.map((obj, index) => {
                          return (
                            <span
                              style={{ padding: "0 3px", cursor: "pointer" }}
                            >
                              <a
                                style={
                                  this.state.current == obj
                                    ? {
                                        fontWeight: "bold",
                                        color: BLUE_COLOR,
                                        fontSize: "30px",
                                      }
                                    : {}
                                }
                                onClick={() => this.pageChange(obj)}
                              >
                                {obj + 1}
                              </a>
                            </span>
                          );
                        })}
                      </div>
                    </TableContainer>
                  </Grid>
                  <Divider style={{ marginTop: 15 }} />
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs></Grid>
                    <Grid item xs></Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 20 }}></Grid>
                </div>
              </Box>
            </form>
          </Paper>
        </Box>
      </Fragment>
    );
  }
}
